export const actionTypes = {
  GET_PAYMENT_RECEIPT_LIST_PENDING: "GET_PAYMENT_RECEIPT_LIST_PENDING",
  GET_PAYMENT_RECEIPT_LIST_SUCCESS: "GET_PAYMENT_RECEIPT_LIST_SUCCESS",
  GET_PAYMENT_RECEIPT_LIST_ERROR: "GET_PAYMENT_RECEIPT_LIST_ERROR",

  UPDATE_CURRENT_PAGE_AND_ROW_LIMIT: "UPDATE_CURRENT_PAGE_AND_ROW_LIMIT",

  UPDATE_SEARCH_FILTERS: "UPDATE_SEARCH_FILTERS",
};

const initialState = {
  getPaymentReceiptListPending: false,
  getPaymentReceiptListSuccess: false,
  getPaymentReceiptListError: null,
  //
  paymentReceiptList: [],
  //
  searchFilters: {
    notificationType: "",
  },
  //page states
  currentPageOfTransactionHistory: 1,
  rowsPerPageOfTransactionHistory: 10,
};

export default function subscriptionManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_PAYMENT_RECEIPT_LIST_PENDING:
    case actionTypes.GET_PAYMENT_RECEIPT_LIST_SUCCESS:
    case actionTypes.GET_PAYMENT_RECEIPT_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE_AND_ROW_LIMIT:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
